import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import WhatsAppSistemaNovaPage from '@/pages/dashboard/whatsapp-sistema-nova-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

const whatsappNovaSearchSchema = z.object({
  /** `live` = WhatsApp com QR Code; `oficial` = API oficial da Meta */
  tipo: z.enum(['live', 'oficial']).optional(),
})

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/whatsapp/nova',
)({
  validateSearch: whatsappNovaSearchSchema,
  component: function WhatsAppSistemaNovaRoute() {
    const { dashboardId } = Route.useParams()
    const { tipo } = Route.useSearch()

    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
        <WhatsAppSistemaNovaPage dashboardId={dashboardId} initialTipo={tipo} />
      </ProtectedRoute>
    )
  },
})
